import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-countdown', 'days', 'Days');
Labels.set('ui-countdown', 'hours', 'Hours');
Labels.set('ui-countdown', 'minutes', 'Minutes');
Labels.set('ui-countdown', 'seconds', 'Seconds');
